
export default {
  components: {
    hotNewHeroLeft: () => import('~/components/Organisms/NewHeroLeft/NewHeroLeft.vue'),
    hotPricingCallToAction: () => import('~/components/Organisms/Pricing/PricingCallToAction/PricingCallToAction.vue'),
    hotPricingFeatures: () => import('~/components/Organisms/Pricing/PricingFeatures/PricingFeatures.vue'),
    hotPricingExtras: () => import('~/components/Organisms/Pricing/PricingExtras/PricingExtras.vue'),
    hotHomeFaq: () => import('~/components/Organisms/HomeFaq/HomeFaq.vue'),
  },
}
